import { gql } from '__generated__';

export default gql(`
  mutation DeactivateInvitation($id: ID!) {
    deactivateInvitation(id: $id) {
      id
      active
    }
  }
`);
